import { inject, Injectable } from '@angular/core';

import {
  ANALYTICS_EVENTS,
  EVENT_CLICK_TYPE,
  HEADER_MENU,
  HEADER_TOP_MENU,
  MenuSection,
  SecondaryNavigationID,
  USER_LOGGED_IN_STATUS
} from '../../../constants/utils';
import { adobeClickEventAnalyticsMocks } from '../../../mocks/utils';
import {
  DashboardResponse,
  loginAndGetDashboardResponse
} from '../../../models/login';
import {
  ClickEventAnalytics,
  PageLoadAnalytics
} from '../../../models/utils/analytics.interfaces';
import { UserSessionService } from '../../login/data-services/user-session/user-session.service';
import { AnalyticsService } from '../analytics/analytics.service';

declare let idp: Record<string, unknown>;

@Injectable({
  providedIn: 'root'
})
export class AdobeDataLayerService {
  analytics = inject(AnalyticsService);
  constructor(private userSession: UserSessionService) {}

  setUserDataInAnalytics(data: ClickEventAnalytics | PageLoadAnalytics): void {
    this.userSession
      .getUserSession()
      .subscribe((userStatus: DashboardResponse) => {
        data = {
          ...data,
          ...{
            user: {
              attributes: {
                is_logged_in: userStatus?.loggedIn
                  ? USER_LOGGED_IN_STATUS.AUTHENTICATED
                  : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
              }
            }
          }
        };
        this.analytics.setAnalytics(data);
      });
  }

  updateAnalytics(
    url: string,
    navItem: keyof typeof HEADER_MENU,
    subNavItem = ''
  ): void {
    let headerMenu: MenuSection;

    if (subNavItem !== '') {
      const navSection = HEADER_MENU[navItem];
      headerMenu = navSection[
        subNavItem as keyof typeof navSection
      ] as unknown as MenuSection;
    } else {
      headerMenu = HEADER_MENU[navItem] as MenuSection;
    }

    const { NAME, PAGE_SECTION } = headerMenu;
    let data = adobeClickEventAnalyticsMocks;
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: NAME,
        type: EVENT_CLICK_TYPE.BUTTON,
        page_section: PAGE_SECTION,
        action: url
      }
    };
    this.setUserDataInAnalytics(data);
  }

  appNavLinksAnalytics(
    navItem: SecondaryNavigationID,
    secondaryNav: string,
    url: string
  ): void {
    const menus = {
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'sky-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    let data = adobeClickEventAnalyticsMocks;
    const { NAME, PAGE_SECTION } = HEADER_MENU[menus[navItem]];
    data = {
      ...data,
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: ANALYTICS_EVENTS.CLICK,
      click: {
        name: NAME,
        type: EVENT_CLICK_TYPE.LINK,
        page_section: `${PAGE_SECTION}:${secondaryNav}`,
        action: url
      }
    };
    this.setUserDataInAnalytics(data);
  }

  setDdcfbDataForStandalonePage(
    response: Partial<DashboardResponse> | loginAndGetDashboardResponse
  ) {
    const dataLayer = idp['dataLayer'] as Record<string, unknown> | undefined;
    const digitalData = dataLayer?.['digitalData'] as
      | Record<string, unknown>
      | undefined;
    const user = digitalData?.['user'] as Record<string, unknown> | undefined;
    const dataObject = user?.['ddcfbData'] as
      | Record<string, unknown>
      | undefined;

    if (dataObject) {
      dataObject['crprtAgrmntTypeCode'] = response['crprtAgrmntTypeCode'];
      dataObject['pgmType'] = response['pgmType'];
      dataObject['pgm'] = response['program'];
      dataObject['permissions'] = response['permType'];
    }
  }
}
